import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/sections/Header";
import Sustainability from "@/sections/Sustainability";
import FooterSection from "@/sections/Footer";

export default function SustainabilityPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    const prev = document.title;
    document.title = "Sustainability — DCYB";
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <main data-testid="sustainability-page" className="relative">
      <Header />

      {/* Back to home strip */}
      <div className="border-b hairline bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-11 md:pt-14 pb-6">
          <Link
            to="/"
            data-testid="back-to-home-link"
            className="inline-flex items-center gap-2 font-mono-label text-[11px] text-[#5F6168] hover:text-[#0F1117] transition-colors"
          >
            <ArrowLeft size={14} />
            Back to DCYB
          </Link>
        </div>
      </div>

      <Sustainability />

      <FooterSection />
    </main>
  );
}
